import { login } from "./login";

export class AuthService {
  constructor () {
    this.login = login;
  }
}
